import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { WhatsAppButton } from './components/WhatsAppButton';
import { initMetaPixel } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <>
      <LandingPage data-id="element-0" />
      <WhatsAppButton data-id="element-1" />
    </>;
}